import { Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { MarketDialogueInviteDto } from "../../autogen/bff-api";
import { isApiErrorDto } from "../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../common/errors/isFetchBaseQueryError";
import { useDisplayDateWithTime } from "../../common/formatting/useDisplayDateWithTime";

export const MarketDialogueInviteFacts = ({ invite }: { invite: MarketDialogueInviteDto }) => {
  const { t } = useTranslation();
  const displayDateWithTime = useDisplayDateWithTime();
  return (
    <Stack spacing="2">
      <Text fontSize="2xl" fontWeight="bold">
        {t("{{buyer}} invites you to a market dialogue", { buyer: invite.buyerOrganizationName })}
      </Text>
      <Text fontSize="lg">{invite.title}</Text>
      {invite.answerDeadline && (
        <Text fontSize="sm" color="smMuted">
          {t("Answer deadline")}: {displayDateWithTime(invite.answerDeadline)}
        </Text>
      )}
      <Text fontSize="sm" color="smMuted">
        {t("Answering is voluntary, and your answer does not commit you to anything.")}
      </Text>
    </Stack>
  );
};

const hasErrorCode = (error: unknown, code: string): boolean =>
  isFetchBaseQueryError(error) && isApiErrorDto(error.data) && error.data.errorCode === code;

export const isInviteRateLimited = (error: unknown) =>
  hasErrorCode(error, "zz_MarketDialogueApiErrorCodeInviteRateLimited");

export const isInviteGone = (error: unknown) => hasErrorCode(error, "zz_MarketDialogueApiErrorCodeInviteNotFound");

export const isWrongInviteLink = (error: unknown) => isFetchBaseQueryError(error) && error.status === 403;
